export default __webpack_public_path__ + "static/media/lady token 1.22348168.svg";